import { useNavigate } from "react-router-dom";
import type { Pojo } from "../app-patient/_objects-patient";
import { type BusinessType } from "../config";
import { routeParent } from "../utils/routing";
import IOPanel from "./io-panel";

export default function IOPanelWithNavigation<T extends Pojo>(props: {
  basePath: string; // blablabla/type -> will be blablabla/type/(:id|add)/:mode
  apiRootUrl: string;
  type: BusinessType;
  file: T;
  hidden?: boolean;
  restrictedForWrite: string;
  restrictedForUnlock?: string;
  children: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  closed?: boolean;
  edit?: boolean;
  canBeLocked?: boolean;
  isProtected?: boolean;
  prepareData?: (file: FormData) => FormData | Record<string, unknown>;
  validateData?: (data: object) => string[];
  onCreated: (file: T) => void;
  onUpdated: (file: T) => void;
  onDeleted: (file: T) => void;
}): React.ReactNode {
  const navigate = useNavigate();
  const typeRootPath = props.basePath;

  if (props.hidden) {
    return;
  }

  if (props.canBeLocked && !props.restrictedForUnlock) {
    throw new Error(
      `IOPanelWithNavigation: canBeLocked is true but restrictedForUnlock is not set for type ${props.type}`
    );
  }

  return (
    <IOPanel<T>
      {...props}
      onEdit={(edit: boolean) => {
        if (props.file.id) {
          // Already got the File
          if (edit) {
            navigate(`${typeRootPath}/${props.file.id}/edit`);
          } else {
            navigate(`${typeRootPath}/${props.file.id}`);
          }
        } else {
          // Add mode
          if (edit) {
            navigate(`${typeRootPath}/add`);
          } else {
            navigate(routeParent(typeRootPath ?? "", 1));
          }
        }
      }}
      onCreated={(file: T) => {
        props.onCreated(file);
        navigate(`${typeRootPath}/${file.id}`);
      }}
    >
      {props.children}
    </IOPanel>
  );
}
